import { useState } from "react";
import { api } from "../api";
import type { Me } from "../me";

export function PinUnlock({
  onUnlocked,
}: {
  onUnlocked: (me: Me) => void;
}) {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  return (
    <form
      className="card"
      onSubmit={async (e) => {
        e.preventDefault();
        setErr("");
        try {
          await api("/api/v1/family/unlock", { method: "POST", body: JSON.stringify({ pin }) });
          const me = await api<Me>("/api/v1/me");
          onUnlocked(me);
        } catch (ex) {
          setErr((ex as Error).message);
        }
      }}
    >
      <h2>Раздел взрослого</h2>
      <p>Код защищает покупки, награды и настройки при использовании общего устройства.</p>
      <label className="field">
        Введите код
        <input
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
          inputMode="numeric"
          autoComplete="off"
          maxLength={4}
        />
      </label>
      {err ? <p className="alert">{err}</p> : null}
      <button className="btn" type="submit">Открыть раздел взрослого</button>
      <p className="muted">Не помню код. <a href="/auth/reset">Подтвердите вход паролем или одноразовой ссылкой, чтобы создать новый код</a>.</p>
    </form>
  );
}

export async function lockParent(onLocked: (me: Me) => void) {
  await api("/api/v1/family/lock", { method: "POST", body: "{}" });
  const me = await api<Me>("/api/v1/me");
  onLocked(me);
}
